import underscore from 'underscore';

if (typeof window !== 'undefined' && typeof window._ === 'undefined') {
  window._ = underscore as unknown as typeof window._;
}

export default underscore;
